import clsx from 'clsx';
import type { ReactNode } from 'react';
import styles from './Badge.module.css';

export type BadgeTone = 'default' | 'accent' | 'positive' | 'warning' | 'danger';

export interface BadgeProps {
  children: ReactNode;
  tone?: BadgeTone;
  className?: string;
}

export function Badge({ children, tone = 'default', className }: BadgeProps) {
  return (
    <span className={clsx(styles.badge, styles[tone], className)}>
      {children}
    </span>
  );
}
